import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const Rewarded: FunctionalComponent<IIconProps> = ({ width = '16', height = '16', fill = '#666' }) => {
  return (
    /*@ts-ignore*/
    <svg
      viewBox="0 0 16 16"
      fill="none"
      width={width}
      height={height}
      color="inherit"
      class="css-dssdj8-SvgIcon ezc9xbs0"
    >
      <path
        fill={fill}
        fill-rule="evenodd"
        d="M8 13.333c2.946 0 5.334-2.388 5.334-5.333 0-2.946-2.388-5.333-5.334-5.333-2.945 0-5.333 2.387-5.333 5.333 0 2.945 2.388 5.333 5.333 5.333zm0 1.334c3.682 0 6.667-2.985 6.667-6.667S11.682 1.333 8 1.333 1.333 4.318 1.333 8 4.319 14.667 8 14.667z"
        clip-rule="evenodd"
      />
      <path
        fill={fill}
        fill-rule="evenodd"
        d="M8.32 4.74c-.358-.174-.791-.03-.968.326l-.69 1.384-1.543.222c-.157.023-.302.096-.413.21-.28.283-.274.738.013 1.015l1.115 1.077-.263 1.52c-.027.156-.001.316.073.456.186.351.623.485.976.301L8 10.533l1.38.718c.14.073.302.099.458.072.393-.067.659-.437.59-.83l-.262-1.519 1.115-1.077c.114-.11.188-.254.211-.41.058-.395-.218-.758-.612-.815L9.338 6.45l-.69-1.384c-.07-.141-.186-.256-.329-.325zM7.543 7.09L8 6.173l.456.916c.106.212.31.358.545.392l1.017.146-.735.71c-.17.164-.25.402-.209.636l.174 1.003-.912-.475c-.21-.11-.462-.11-.672 0l-.912.475.174-1.003c.04-.234-.038-.472-.209-.636l-.735-.71L7 7.481c.235-.034.439-.18.545-.392z"
        clip-rule="evenodd"
      />
    </svg>
  );
};

export default Rewarded;

export const rewardedString = `<svg viewBox="0 0 16 16" fill="none" width="24" height="24" color="inherit">
    <path
      fill="#666"
      fill-rule="evenodd"
      d="M8 13.333c2.946 0 5.334-2.388 5.334-5.333 0-2.946-2.388-5.333-5.334-5.333-2.945 0-5.333 2.387-5.333 5.333 0 2.945 2.388 5.333 5.333 5.333zm0 1.334c3.682 0 6.667-2.985 6.667-6.667S11.682 1.333 8 1.333 1.333 4.318 1.333 8 4.319 14.667 8 14.667z"
      clip-rule="evenodd"
    />
    <path
      fill="#666"
      fill-rule="evenodd"
      d="M8.32 4.74c-.358-.174-.791-.03-.968.326l-.69 1.384-1.543.222c-.157.023-.302.096-.413.21-.28.283-.274.738.013 1.015l1.115 1.077-.263 1.52c-.027.156-.001.316.073.456.186.351.623.485.976.301L8 10.533l1.38.718c.14.073.302.099.458.072.393-.067.659-.437.59-.83l-.262-1.519 1.115-1.077c.114-.11.188-.254.211-.41.058-.395-.218-.758-.612-.815L9.338 6.45l-.69-1.384c-.07-.141-.186-.256-.329-.325zM7.543 7.09L8 6.173l.456.916c.106.212.31.358.545.392l1.017.146-.735.71c-.17.164-.25.402-.209.636l.174 1.003-.912-.475c-.21-.11-.462-.11-.672 0l-.912.475.174-1.003c.04-.234-.038-.472-.209-.636l-.735-.71L7 7.481c.235-.034.439-.18.545-.392z"
      clip-rule="evenodd"
    />
  </svg>`;
